module.exports = "/_next/static/images/text-pic-4e2f248e874c77cae8d5c4dfc1a6dac4.jpg";